<!--
 * @Author: cgh
 * @Date: 2022-08-03 14:22:10
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 14:52:16
 * @Description: 建筑信息
-->
<template>
  <!-- 页面头部 Start -->

  <!-- 页面头部 End -->
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-80 o-dialog--xl-80 o-dialog-h--75"
    title="建筑信息"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <!-- 查询条件 Start -->
    <div
      class="l-page l-page--search"
    >
      <div
        class="l-page__header c-page__header"
      >
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-form-item
            class="c-form__item"
            label="建筑名称"
            prop="jzwmc"
          >
            <el-input
              v-model.trim="filterParams.jzwmc"
              class="c-form__input"
              placeholder="建筑名称"
              clearable
            />
          </el-form-item>
        </el-form>
        <div
          class="c-page__header-btns"
          style="margin-left: 20px;"
        >
          <k-button
            btn-text="查询"
            :auth-type="false"
            type="primary"
            icon="kestrel-icon ki-search"
            @click="init()"
          />
          <k-button
            btn-text="重置"
            :auth-type="false"
            icon="kestrel-icon ki-repeat"
            @click="resetForm()"
          />
          <k-button
            v-if="dlParams.type === 'edit'"
            btn-text="新增"
            :auth-type="true"
            type="success"
            icon="kestrel-icon ki-plus"
            @click="handleDialog('add',{xmid:xmid})"
          />
          <!-- 查询条件表单 End -->
        </div>
      </div>

      <!-- 查询条件 End -->
      <!-- 页面主内容：查询列表 Start -->
      <div
        class="l-page__body l-page--search__body"
      >
        <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
        <!-- table的ref的命名根据业务名称修改 -->
        <k-table
          ref="kTable"
          height="100%"
          :table-column="tableColumn"
          :data="jzxxList.rows"
          :pagination="jzxxList"
          :pagination-show="true"
          @current-change="init"
          @size-change="handleSizeChange"
        >
          <el-table-column
            v-if="dlParams.type === 'edit'"
            prop="enabled"
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template
              slot-scope="scope"
            >
              <k-button
                btn-text="编辑"
                :auth-type="true"
                type="primary"
                plain
                @click="handleDialog('edit',{ xmid:xmid,id: scope.row.id })"
              />
              <k-button
                btn-text="删除"
                :auth-type="true"
                type="danger"
                @click="handleDel(scope.row, scope.$index)"
              />
            </template>
          </el-table-column>
        </k-table>
      </div>
      <!-- -->
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
    <!-- 添加/修改 -->
    <update-jzxx-dialog
      v-if="showDialogName === 'edit' || showDialogName === 'add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="init()"
    />
  </el-dialog>
</template>

<script>
import { jzxxService } from './jzxx.service.js';
export default {
  name: 'JzxxDialog',
  components: {
    updateJzxxDialog: () => import('./updateJzxxDialog')
  },
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      xmid: null,
      loading: false, // 页面是否加载
      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'jzwmc', label: '建筑名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'zdmj', label: '占地面积（m²）', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jzmj', label: '建筑面积（m²）', align: 'left', minWidth: '80', type: 'text' },
        { key: 'lcs', label: '楼层数', align: 'center', minWidth: '80', type: 'text' },
        { key: 'jzgd', label: '建筑高度（m）', align: 'center', minWidth: '80', type: 'text' }
      ],
      /* 表格列配置End */
      fd: {
      },
      // 查询条件
      filterParams: {
        jzwmc: null
      },
      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */
      multipleSelectedRow: [], // 表格选中行（多选）
      jzxxList: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      }
    };
  },
  methods: {
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.jzxxList.pageSize = val;
      this.init();
    },
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return {*}
     */
    handleSelectionChange (val) {
      this.multipleSelectedRow = val;
    },
    /**
       * @description: 跳转窗口
       * @author: cgh
       */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * 初始化数据
     */
    init () {
      this.loading = true;
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      jzxxService.jzxxQuery(this.xmid, this.trueFilterParams)
        .then(rsp => {
          this.jzxxList = Object.assign({}, this.jzxxList, rsp.data);
        })
        .catch(err => {
          console.error('获取建筑题信息错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此评估成员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        jzxxService.delJzxx(this.xmid, _row.id)
          .then(rsp => {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            _this.init();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    }

  },
  created () {
    this.xmid = this.dlParams.id;
    this.init();
  }
};

</script>
